module.exports = __webpack_public_path__ + "img/starbucks.836bb344.svg";